<template>
  <div class="payment-container">
    <div class="payment-content">
      <div class="payment-header">
        <h1 class="payment-title earth-color">
          Booking confirmed
        </h1>
        <div class="payment-progress">
          <div class="progress-step">Details</div>
          <div class="progress-step">Payment</div>
          <div class="progress-step active">Confirmation</div>
        </div>
      </div>

      <div class="main-content">
        <div class="donation-card">
          <div class="donation-title">
            <i class="fas fa-check-circle mr-2" style="color: #4a6b22;"></i>
            Thank you for your booking
          </div>

          <div class="card-content">
            <p>
              Thank you,
              <span style="text-transform: capitalize">{{ singleBooking.booking_details.first_name }}</span>
            </p>
            <p><strong>Your booking has been confirmed.</strong></p>

            <div class="payment-instructions">
              <p>
                Booking reference:
                <strong>{{ singleBooking.booking_ref_code }}</strong>
              </p>
              <p>
                Total Number of Guests:
                <b>{{ singleBooking.guest_total }}</b>
              </p>
            </div>

            <div class="mt-4">
              <h3 class="methods-title">Dates Selected:</h3>
              <ul>
                <li>
                  Booking Checkin Date:
                  <b>{{ singleBooking.check_in_date }}</b>
                </li>
                <li>
                  Booking Check Out Date:
                  <b>{{ singleBooking.check_out_date }}</b>
                </li>
              </ul>
            </div>

            <div class="mt-4">
              <h3 class="methods-title">Conservation Entry Fees:</h3>
              <ul>
                <li v-for="(guest, key) in singleBooking.guests"
                    v-if="guest.payment_guests > 0"
                    :key="key">
                  {{ guest.payment_person }}:
                  <b>{{ guest.payment_guests }}</b>
                </li>
              </ul>
            </div>

            <div class="mt-4" v-if="singleBooking.facility_bookings.length > 0">
              <h3 class="methods-title">Accommodation Selected:</h3>
              <ul>
                <li v-for="(facility, key) in singleBooking.facility_bookings"
                    :key="key">
                  {{ facility.facility_name }}
                </li>
              </ul>
            </div>

            <div class="mt-4">
              <h3 class="methods-title">Conservation Activities Selected:</h3>
              <ul>
                <li v-for="(activity, key) in singleBooking.inventory_bookings"
                    :key="key">
                  {{ activity.inventory_name }} on
                  {{
                    formated_date(activity.inventory_booking_date)
                  }}
                  for {{ activity.inventory_booking_adults }} adults and
                  {{ activity.inventory_booking_children }} children.
                </li>
              </ul>
            </div>

            <div class="mt-4">
              <h3 class="methods-title">Vehicle Fee:</h3>
              <p><b>{{ singleBooking.vehicle_count }}</b></p>
            </div>

            <div class="mt-4">
              <h3 class="methods-title">Amount:</h3>
              <p>
                <b>
                  {{ singleBooking.currency }}
                  {{
                    singleBooking.total_cost
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                  }}
                </b>
              </p>
            </div>

            <div class="email-confirmation">
              <i class="fas fa-envelope"></i>
              <p>
                An email confirmation has been sent to
                <b>{{ singleBooking.booking_details.email_address }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    created() {
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
    },
    methods: {
      formated_date(date) {
        // Add your date formatting logic here
        return date;
      }
    }
  };
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  /* Main Container Styles */
  .payment-container {
    background-color: #f9f9f9;
    min-height: 100vh;
    padding: 20px;
  }

  .payment-header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .payment-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 2.5rem;
    margin-bottom: 15px;
    letter-spacing: 1px;
    color: #4a6b22;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
  }

  .payment-progress {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .progress-step {
    padding: 10px 20px;
    margin: 0 10px;
    background-color: #e0e0e0;
    border-radius: 20px;
    font-weight: 500;
    color: #666;
    position: relative;
  }

    .progress-step.active {
      background-color: #74a533;
      color: white;
      box-shadow: 0 4px 8px rgba(116, 165, 51, 0.3);
    }

    .progress-step:not(:last-child):after {
      content: '→';
      position: absolute;
      right: -15px;
      color: #999;
    }

  /* Content Layout */
  .payment-content {
    max-width: 1200px;
    margin: 0 auto;
  }

  .main-content {
    background-color: white;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  }

  /* Donation Card Styles */
  .donation-card {
    background-color: #f5f9f0;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 30px;
    border: 1px solid #e0e8d0;
  }

  .donation-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.5rem;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    color: #4a6b22;
  }

  /* Payment Methods Section */
  .methods-title {
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.2rem;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    color: #4a6b22;
  }

  .payment-instructions {
    margin-top: 15px;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 5px;
    font-size: 0.9rem;
    color: #666;
  }

  .email-confirmation {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: #fff8e1;
    border-radius: 5px;
    font-size: 0.9rem;
    margin-top: 20px;
  }

    .email-confirmation i {
      margin-right: 10px;
      color: #ffc107;
    }

  /* Earth Color Class */
  .earth-color {
    color: #4a6b22;
  }

  /* Responsive Styles */
  @media (max-width: 960px) {
    .main-content {
      margin-left: 0 !important;
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .payment-title {
      font-size: 1.8rem;
    }

    .progress-step {
      padding: 8px 12px;
      font-size: 0.8rem;
    }

    .donation-title, .methods-title {
      font-size: 1.2rem;
    }
  }
</style>
